import { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { apiRequest } from "src/async/apiUtils";
import { logoutRedirect } from "src/async/fetch";
import AuthLayout from "src/layouts/AuthLayout";
import { AuthContext } from "src/context/auth";
import { getNavigateLink } from "src/helpers/userHelper";
import { useWorkspaceSwitching } from "src/context/WorkspaceSwitchingContext";

const FreeAuthRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useContext(AuthContext);
  const { startSwitching } = useWorkspaceSwitching();

  const clickWorkspace = async () => {
    try {
      const { data: resData } = await apiRequest("GET", `/portal/users/workspaces/page`);
      if (resData.status === 200) {
        const navigate_link = getNavigateLink(resData);
        navigate(navigate_link);
      } else {
        navigate("/permission-denied");
      }
    } catch (err) {
      navigate("/permission-denied");
    }
  };

  const redirectToWorkspace = async () => {
    try {
      const { data: resultData } = await apiRequest("post", "/portal/users/self/details", {
        body: {
          token: localStorage.getItem("accessToken"),
          access_token: localStorage.getItem("accessToken"),
        },
      });

      if (resultData.status !== 200) {
        logoutRedirect();
      }

      setUser(resultData.data);

      clickWorkspace();
    } catch (err) {
      // navigate("/permission-denied");
      logoutRedirect();
    }
  };

  useEffect(() => {
    if (localStorage.getItem("accessToken") && location.pathname !== "/sso-login" && !location.pathname.includes("forgot-password") && !location.pathname.includes("token") && !window.location.pathname.includes("/storage")) {
      redirectToWorkspace();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (localStorage.getItem("accessToken") && location.pathname !== "/sso-login") {
    if (location.pathname.includes("forgot-password") || location.pathname.includes("token")) {
      logoutRedirect(window.location.href);
      return <></>;
    }

    return startSwitching();
  }

  return <AuthLayout />;
};

export default FreeAuthRoute;
